import API from "./axiosConfig";

// const API = axios.create({
// Ensure axios will send cookies when needed (server must allow credentials)
API.defaults.withCredentials = true;
//     baseURL: process.env.REACT_APP_URL,
// Attach Authorization header at request time. This avoids stale token issues and
// makes it easier to inspect headers per request (useful when debugging mobile vs desktop emulation).
API.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers = config.headers ?? {};
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    } catch (e) {
      console.warn("withAuthProvider: localStorage access error", e);
      // ignore localStorage access errors (e.g., SSR)
    }

    // In development enable a light-weight debug log so you can compare requests
    if (process.env.NODE_ENV !== "production" && typeof window !== "undefined") {
      // Toggle window.__DEBUG_API_HEADERS__ = true in console to enable logging
      if (window.__DEBUG_API_HEADERS__) {
        // eslint-disable-next-line no-console
        console.debug("[API] request", config.url, config.method, config.headers);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);
//     headers: {
//         'Content-Type': 'application/json',
//         'Access-Control-Allow-Origin': '*'
//     }
// });

function buildResponse(response) {
  return response;
}

const token = localStorage.getItem("token");

API.defaults.headers.common["Authorization"] = `Bearer ${token}`;

const withAuthProvider = {
  setToken(token) {
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  },
  getDataWithAuth: async (url, parameter) => {
    return API.get(`${url}`, {
      params: parameter,
    })
      .then((response) => buildResponse(response))
      .catch((err) => buildResponse(err.response ?? null));
  },
  getDataProfile: async () => {
    return API.get(`/api/account/profile`, {})
      .then((response) => buildResponse(response))
      .catch((err) => buildResponse(err.response ?? null));
  },
  postDataWithAuth: async (url, body) => {
    return API.post(`${url}`, body)
      .then((response) => buildResponse(response))
      .catch((err) => buildResponse(err.response ?? null));
  },
  postDataWithAuthFormData: async (url, body) => {
    return API.post(`${url}`, body, { headers: { "Content-Type": "multipart/form-data" } })
      .then((response) => buildResponse(response))
      .catch((err) => buildResponse(err.response ?? null));
  },
  deleteDataWithAuth: async (url) => {
    return API.delete(`${url}`)
      .then((response) => buildResponse(response))
      .catch((err) => buildResponse(err.response ?? null));
  },
};

export default withAuthProvider;
